import { render, staticRenderFns } from "./DocumentsSidebar.vue?vue&type=template&id=1083b866"
import script from "./DocumentsSidebar.vue?vue&type=script&lang=ts"
export * from "./DocumentsSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1083b866')) {
      api.createRecord('1083b866', component.options)
    } else {
      api.reload('1083b866', component.options)
    }
    module.hot.accept("./DocumentsSidebar.vue?vue&type=template&id=1083b866", function () {
      api.rerender('1083b866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/managers/DocumentsSidebar.vue"
export default component.exports